function sliderlistLogo (slider) {
  var swiperName = ".listLogosSwiper-" + $(slider).attr('data-section-id');
  var swiperpagination = ".js-list-logos-swiper-pagination-" + $(slider).attr('data-section-id');
  var swipernextEl = ".js-list-logos-swiper-button-next-" + $(slider).attr('data-section-id');
  var swiperprevEl = ".js-list-logos-swiper-button-prev-" + $(slider).attr('data-section-id');
  var swiper = new Swiper(swiperName, {
    slidesPerView: 2,
    spaceBetween: 10,
    centeredSlides: false,
    loop: false,
    pagination: {
      el: swiperpagination,
      clickable: true,
    },
    navigation: {
      enabled: false,
      nextEl: swipernextEl,
      prevEl: swiperprevEl,
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 10,
        centeredSlides: false,
        navigation: {
          enabled: false
        },
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
        centeredSlides: false,
        loop: false,
        navigation: {
          enabled: true
        },
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 30,
        centeredSlides: false,
        loop: false,
        navigation: {
          enabled: true
        },
      },
    },
  });
}

$('.listLogosSwiper').each(function(index, el) {
  sliderlistLogo(el);
});